import actions from './actions';
import mutations from './mutations';
import state from './initialState';
const Content = {
    state,
    actions,
    mutations
};
export default Content;
